import React, { useState, useEffect } from 'react';

const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

export const useCountUp = (target, active, duration = 2000) => {
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!active) return;

    let frameId;
    const startTime = performance.now();

    const tick = (now) => {
      const progress = Math.min((now - startTime) / duration, 1);
      setValue(Math.round(target * easeOutCubic(progress)));

      if (progress < 1) {
        frameId = requestAnimationFrame(tick);
      } else {
        setValue(target);
      }
    };

    frameId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frameId);
  }, [target, active, duration]);

  return value;
};

export const formatNumber = (num) =>
  num.toLocaleString('ru-RU').replace(/\u00A0/g, ' ');
